"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as i, forwardRef as n } from "react";
import { useSvgIcon as l } from "../useSvgIcon.js";
const c = i(
  n((e, r) => {
    const t = l({
      ...e,
      ref: r
    });
    return /* @__PURE__ */ o(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t(),
        children: /* @__PURE__ */ o(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.5349 5H4L13.006 17.0336L4.48837 27H8.11628L14.7158 19.3184L20.4651 27H28L18.4767 14.2857L26.3953 5H22.7674L16.7674 12L11.5349 5ZM10.3238 7.07143H8.23129L21.4419 24.7857H23.5343L10.3238 7.07143Z",
            fill: "var(--icon-color)"
          }
        )
      }
    );
  })
);
c.displayName = "IconTwitter";
export {
  c as IconTwitter
};
